import * as React from 'react';
import { cn } from '../../../utils';

export interface VocabClipProps {
  /** uppercase condensed term, e.g. "push back" */
  term: React.ReactNode;
  /** pink uppercase category, e.g. "phrasal verb" */
  category?: React.ReactNode;
  /** muted definition text */
  definition?: React.ReactNode;
  /**
   * alternate rotation (-.8deg instead of .6deg) — pass true for
   * even-indexed clips to reproduce the spec's nth-child(2n) stagger.
   */
  alt?: boolean;
  className?: string;
}

/**
 * White "clipping" card with a pink tape strip on top and a slight
 * rotation, used for vocabulary in the spread's aside column.
 */
export function VocabClip({ term, category, definition, alt, className }: VocabClipProps) {
  return (
    <div className={cn('z-clip', alt && 'z-clip--alt', className)}>
      <b>{term}</b>
      {category != null && <i>{category}</i>}
      {definition != null && <p>{definition}</p>}
    </div>
  );
}
